// extracted by mini-css-extract-plugin
export default {"empty":"CustomerDevices_empty__ngjtq"};